/**
 * Typographie partagée pour tous les composants de verdict / cockpit.
 *
 * Objectif : uniformiser les blocs de texte prose (question posée, phrase
 * qui tranche, messages de statut) — DM Sans, non italique, 17px, ivory/ink.
 * Interdit d'utiliser Playfair Display italique pour de la prose lisible.
 */

export const VERDICT_FONT_SANS =
  "'DM Sans', system-ui, -apple-system, Segoe UI, sans-serif";
export const VERDICT_FONT_MONO =
  "'DM Mono', 'JetBrains Mono', ui-monospace, monospace";
export const VERDICT_FONT_DISPLAY =
  "'Playfair Display', Georgia, serif";

/** Prose lisible : question, phrase qui tranche, message d'état. */
export const verdictProseStyle = {
  fontFamily: VERDICT_FONT_SANS,
  fontStyle: "normal" as const,
  fontSize: 17,
  lineHeight: 1.5,
  letterSpacing: "-0.005em",
};

/** Petite prose (chip explicatif, aside). */
export const verdictProseSmallStyle = {
  fontFamily: VERDICT_FONT_SANS,
  fontStyle: "normal" as const,
  fontSize: 14,
  lineHeight: 1.55,
};

/** Label mono (eyebrow, catégorie). */
export const verdictLabelStyle = {
  fontFamily: VERDICT_FONT_MONO,
  fontSize: 10,
  letterSpacing: 3,
  textTransform: "uppercase" as const,
};
